import { render, staticRenderFns } from "./recieverConflict.vue?vue&type=template&id=5d547ad5&scoped=true"
import script from "./recieverConflict.vue?vue&type=script&lang=js"
export * from "./recieverConflict.vue?vue&type=script&lang=js"
import style0 from "./recieverConflict.vue?vue&type=style&index=0&id=5d547ad5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d547ad5",
  null
  
)

export default component.exports